import { createAction } from 'redux-actions';

export const getInvestmentQuotesV2 = createAction('GET_INVESTMENT_QUOTES_V2', (payload) => payload, (payload, meta) => meta);
export const getInvestmentQuotesV2Success = createAction('GET_INVESTMENT_QUOTES_V2_SUCCESS');
export const getInvestmentQuotesV2Failure = createAction('GET_INVESTMENT_QUOTES_V2_FAILURE');
